import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getSettings = (
    backend: string,
    token: string
) => {
    return fetch(
        `${getApiUrl(backend)}settings`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain, */*'
            },
        }
    );
};

export default getSettings;
